var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "layout__bottom" },
        [
          _c(
            "el-col",
            { attrs: { span: 8 } },
            [
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: { effect: "dark", placement: "top-start" }
                },
                [
                  _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                    _vm._v(_vm._s((_vm.isCollapse ? "打开" : "关闭") + "导航"))
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "iconfont icon-navicon",
                    on: { click: _vm.toggleCollapse }
                  })
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { staticClass: "right", attrs: { span: 16 } },
            [
              _vm.isClient
                ? [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "dark", placement: "top" }
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.currentMessage.tooltip,
                                expression: "currentMessage.tooltip"
                              }
                            ],
                            attrs: { slot: "content" },
                            slot: "content"
                          },
                          [_vm._v(_vm._s(_vm.currentMessage.tooltip))]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "layout__bottom__text",
                            class: { success: _vm.success, fail: !_vm.success },
                            on: { click: _vm.connectSpecialNetWork }
                          },
                          [
                            _vm.currentMessage.icon
                              ? _c("i", { class: _vm.currentMessage.icon })
                              : _vm._e(),
                            _vm._v(" " + _vm._s(_vm.currentMessage.message))
                          ]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: { effect: "dark", placement: "top" }
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.currentMessage.tooltip,
                                expression: "currentMessage.tooltip"
                              }
                            ],
                            attrs: { slot: "content" },
                            slot: "content"
                          },
                          [_vm._v(_vm._s(_vm.currentMessage.tooltip))]
                        ),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "iconfont icon-wifi",
                          on: { click: _vm.connectSpecialNetWork }
                        })
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content: "产品幕后人员",
                    effect: "dark",
                    placement: "top"
                  }
                },
                [
                  _c("i", {
                    staticClass: "iconfont icon-renyuan-kaoqin",
                    on: {
                      click: function($event) {
                        _vm.staffVisible = true
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content: "保单号批量处理小工具",
                    effect: "dark",
                    placement: "top"
                  }
                },
                [
                  _c("i", {
                    staticClass: "iconfont icon-num",
                    on: { click: _vm.openTool }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: {
                    content: "刷新当前页",
                    effect: "dark",
                    placement: "top"
                  }
                },
                [
                  _c("i", {
                    staticClass: "iconfont icon-shuaxin",
                    on: { click: _vm.refresh }
                  })
                ]
              ),
              _vm._v(" "),
              _vm.isClient
                ? [
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          content: "关闭VPN",
                          effect: "dark",
                          placement: "top"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "iconfont icon-shanchu",
                          on: { click: _vm.closeVPN }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: "清理缓存",
                          effect: "dark",
                          placement: "top"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "iconfont icon-shanchu1",
                          on: { click: _vm.clearCache }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          content: "打开新页面",
                          effect: "dark",
                          placement: "top"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "iconfont icon-fuzhi",
                          on: { click: _vm.openUrl }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.showRepairedTool
                      ? _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: {
                              content: "修复工具箱",
                              effect: "dark",
                              placement: "top"
                            }
                          },
                          [
                            _c("i", {
                              staticClass: "iconfont icon-shezhi",
                              on: { click: _vm.openRepairedTool }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      {
                        staticClass: "item",
                        attrs: {
                          content: "打开新用户",
                          effect: "dark",
                          placement: "top"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "iconfont icon-yonghuzu",
                          on: { click: _vm.openWindow }
                        })
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-tooltip",
                {
                  staticClass: "item",
                  attrs: { content: "锁屏", effect: "dark", placement: "top" }
                },
                [
                  _c("i", {
                    staticClass: "iconfont icon-guanbi1",
                    on: { click: _vm.lockScreen }
                  })
                ]
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("staffDialog", {
        model: {
          value: _vm.staffVisible,
          callback: function($$v) {
            _vm.staffVisible = $$v
          },
          expression: "staffVisible"
        }
      }),
      _vm._v(" "),
      _c(
        "ybl-dialog",
        {
          attrs: {
            visible: _vm.isShowTool,
            title: "保单号批量处理工具",
            width: "1000px",
            showFooter: false,
            top: "15vh"
          },
          on: { close: _vm.close }
        },
        [
          _c("div", [
            _vm._v(
              "1、通过此工具，能批量处理多行文本，将本文内容转换为符合系统输入的多行保(批)单号的规格，降低手工操作输错风险；"
            )
          ]),
          _vm._v(" "),
          _c("div", [_vm._v("2、文本内最大可输入10000文字")]),
          _vm._v(" "),
          _c("div", { staticClass: "deal-container" }, [
            _c(
              "div",
              { staticClass: "deal-item" },
              [
                _c("el-input", {
                  staticClass: "limit-textarea",
                  attrs: {
                    type: "textarea",
                    rows: 8,
                    placeholder: "粘贴待处理的保(批)单号",
                    maxlength: "10000",
                    "show-word-limit": ""
                  },
                  model: {
                    value: _vm.unDealText,
                    callback: function($$v) {
                      _vm.unDealText = $$v
                    },
                    expression: "unDealText"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "deal-translate",
                on: { click: _vm.translateOpt }
              },
              [
                _c("div", [_vm._v("点击转换")]),
                _vm._v(" "),
                _c("div", [
                  _c("i", { staticClass: "el-icon-d-arrow-right arrow-right" })
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "deal-item" },
              [
                _c(
                  "el-tooltip",
                  {
                    staticClass: "item",
                    attrs: {
                      content: "点击复制",
                      effect: "dark",
                      placement: "top"
                    }
                  },
                  [
                    _c("i", {
                      staticClass: "el-icon-document-copy copy-icon",
                      on: { click: _vm.copyValue }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("el-input", {
                  staticClass: "limit-textarea",
                  attrs: {
                    type: "textarea",
                    rows: 8,
                    placeholder: "处理后的区域"
                  },
                  model: {
                    value: _vm.dealText,
                    callback: function($$v) {
                      _vm.dealText = $$v
                    },
                    expression: "dealText"
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f0959a4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0959a4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bottom.vue
// module id = null
// module chunks = 